import { CheckoutStatus as e } from "@ancon/wildcat-types";
function s(a) {
  throw new Error(`Unhandled checkout status: ${a}`);
}
function t(a) {
  switch (a == null ? void 0 : a.status) {
    case e.Error:
    case e.Canceled:
    case e.Authorized:
    case e.Captured:
    case e.InProgress:
    case e.Done:
    case e.ReadyToCollect:
    case e.DeliveryInProgress:
      return !0;
    case e.Created:
    case e.Ready:
    case e.Processing:
    case e.Received:
      return !1;
    default:
      return s(a == null ? void 0 : a.status);
  }
}
export {
  t as default
};
